import { Outlet } from 'react-router-dom';
import BackButton from '../../../../Components/BackButton';
// import Header from '../../../../Layout/Header/Header';
import FrontFooter from '../../../front/components/FrontFooter';
import FrontNav from '../../../front/components/FrontNav';

function EventViewWrapper() {
  scrollTo(top);
  return (
    <div className="front">
      <FrontNav />
      <div className="container" id="events">
        <div className="my-2 py-3">
          <BackButton variant="outline-secondary" style="btn-sm" />

          <Outlet />
        </div>
      </div>
      <div className="position-relative mt-n15">
        <div className="shape shape-bottom shape-fluid-x text-dark">
          <svg viewBox="0 0 2880 48" fill="none" xmlns="../www.w3.org/2000/svg.html">
            <path d="M0 48h2880V0h-720C1442.5 52 720 0 720 0H0v48z" fill="currentColor" />
          </svg>
        </div>
      </div>
      <section className="pt-15 bg-dark" />
      <section className="py-8 py-md-11 bg-dark" />
      <div className="position-relative">
        <div className="shape shape-bottom shape-fluid-x text-gray-200">
          <svg viewBox="0 0 2880 48" fill="none" xmlns="../www.w3.org/2000/svg.html">
            <path d="M0 48h2880V0h-720C1442.5 52 720 0 720 0H0v48z" fill="currentColor" />
          </svg>
        </div>
      </div>
      <FrontFooter />
    </div>
  );
}

export default EventViewWrapper;
